import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import AuthView from './auth-view';
import { Toast } from '../../ui-kit';

const AuthContainer = (props) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [disabled, setDisabled] = useState(true);
  const [focusEmail, setFocusEmail] = useState(false);
  const [focusPassword, setFocusPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorValue, setErrorValue] = useState('');

  const handleAuth = async (mail, pass) => {
    setLoading(true);
    try {
      await props.handleLogIn(mail, pass);
    } catch (e) {
      Toast('error', 'Something went wrong!');
      setPassword('');
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(false);
    setPassword('');
    setErrorValue(props.error);
  }, [props.error]);

  useEffect(() => {
    if (password.length === 0 || email.length === 0) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [password, email]);

  return (
    <AuthView
      error={errorValue}
      email={email}
      password={password}
      loading={loading}
      disabled={disabled}
      focusEmail={focusEmail}
      focusPassword={focusPassword}
      setEmail={setEmail}
      handleAuth={handleAuth}
      setPassword={setPassword}
      setErrorValue={setErrorValue}
      setFocusEmail={setFocusEmail}
      setFocusPassword={setFocusPassword}
    />
  );
};

AuthContainer.propTypes = {
  error: PropTypes.string,
  handleLogIn: PropTypes.func,
};
AuthContainer.defaultProps = {
  error: '',
  handleLogIn: () => {},
};

export default AuthContainer;
